module.exports = __webpack_public_path__ + "img/firstDp.f8167c65.svg";